import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { AssignedClientsApiService } from 'features/assigned-clients/api/assign-clients-api.service';
import { queryClient } from 'providers';

import { AssignClientsQueryKeys } from './query-keys';
const { createMoveDocuments } = AssignedClientsApiService();

export const useMoveDocuments = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return createMoveDocuments(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: AssignClientsQueryKeys.all,
        });
      },
    },
  );
};
